import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getCancellationPolicy } from 'modules/settings/api';

export const useQueryCancellationPolicyDetails = (policyId: string | null) => {
  const {
    data: cancellationPolicy,
    isLoading: isLoadingCancellationPolicy,
    isError: isErrorCancellationPolicy,
    refetch,
  } = useQuery(
    [QUERY_KEYS.SETTINGS_CANCELLATION_POLICY, policyId],
    () => getCancellationPolicy(policyId),
    {
      enabled: !!policyId,
      cacheTime: 0,
    },
  );

  return { cancellationPolicy, isLoadingCancellationPolicy, isErrorCancellationPolicy, refetch };
};
